export const redirect = 'https://soc.scaladatacenters.com/'
export const rotaAutenticação = 'https://soc.scaladatacenters.com/api/'
//export const redirect = 'http://localhost:3000'
//export const rotaAutenticação = 'http://localhost:5000/api/'

export function animationModal(id, id2) {
  let div = document.getElementById(id)
  let background = document.getElementById(id2)
  let param = background.style.visibility
  if (param === 'hidden' || param === '') {
    background.style.visibility = 'visible'
    setTimeout(() => {
      div.classList.add('modal-new-action-aberto')
    }, 100);
  } else {
    div.classList.remove('modal-new-action-aberto')
    setTimeout(() => {
      background.style.visibility = 'hidden'
      const inputs = document.querySelectorAll('input');

      for (let i = 0; i < inputs.length; i++) {
        inputs[i].value = '';
      }
    }, 300);
  }
}
